import Layout from '@/layout';
var jdlLogisticsRouter = {
  path: '/jdl-logistics',
  component: Layout,
  redirect: '/jdl-logistics/workbench',
  name: 'MerJdlLogistics',
  meta: {
    title: '京东物流',
    icon: 'shopping'
  },
  children: [{
    path: 'workbench',
    component: function component() {
      return import('@/views/warehouse/jdlLogistics');
    },
    name: 'MerJdlLogisticsWorkbench',
    meta: {
      title: '物流工作台',
      noCache: true
    }
  }, {
    path: '/warehouse/jdl-logistics',
    redirect: '/jdl-logistics/workbench',
    hidden: true
  }]
};
export default jdlLogisticsRouter;